export const fieldSubscription = {
  value: true,
  invalid: true,
  submitError: true,
  dirtySinceLastSubmit: true,
  error: true,
  dirty: true,
  touched: true,
};
